"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  placeholder: {
    spliter: ' / ',
    empty: {
      blur: 'Search ',
      focus: {
        single: 'Input a value and press Enter',
        multiple: 'Input a value or separate values with "|", and press Enter'
      }
    },
    text: {
      single: 'Input a value and press Enter',
      multiple: 'Separate values with "|" and press Enter'
    },
    select: {
      single: 'Select a value',
      multiple: 'Select values and press Enter'
    }
  },
  filterDropdownLabel: 'Select a filter for advanced search',
  tagHoverTip: 'Click to edit. Enter to confirm.',
  modalTip: {
    title: 'Help',
    th: {
      td1: '-',
      td2: 'Format',
      td3: 'Example',
      td4: 'Search bar',
      td5: 'Description'
    },
    tr1: {
      td1: 'Input an value',
      td2: '【Value】',
      td3: '192.168.1.86',
      td4: '',
      td5: 'Filter IPv4 matching the input value of 192.168.1.86'
    },
    tr2: {
      td1: 'Single filter',
      td2: '【Filter】:【Value】',
      td3: 'Instance ID: 750339712325',
      td4: '',
      td5: 'Filter Instance ID matching 1750339712325259170'
    },
    tr3: {
      td1: 'Batch filters',
      td2: '【Filter】:【Value】【Enter】【Filter】:【Value】',
      td3: 'Instance ID: 750339712325<br/>Instance Name: S9F-MAD-A-02',
      td4: '',
      td5: 'Filter Instance ID matching 1750339712325259170, and Instance Name matching S9F-MAD-A-02'
    },
    tr4: {
      td1: 'Batch values',
      td2: '【Filter】:【Value】｜【Value】',
      td3: 'IPv4: 192.168.1.86 | 192.168.0.0',
      td4: '',
      td5: 'Filter IPv4 matching 192.168.1.86 or 192.168.0.0'
    },
    tr5: {
      td1: 'Paste values',
      td2: 'Enter multiple keywords separated by space, comma (,), pipe (|), or newline',
      td3: '192.168.1.86<br/>192.168.0.0<br/>192.168.0.23',
      td4: '',
      td5: 'Filter IPv4 matching 192.168.1.86, 192.168.0.0 or 192.168.0.23'
    }
  }
};
var _default = exports.default = locale;